import { Rewards } from '@arrived/models';

import { rewardsApi } from '../api';

export const getPromotionRedemption = async (promotionUuid: string) => {
  const response = await rewardsApi.get<Rewards.PromotionRedemption>(`/promotion-redemptions/${promotionUuid}`);
  return response.data;
};

export const postCancelPromotionRedemption = async (
  promotionUuid: string,
  promotionCancelBody?: Rewards.PromotionCancelRedemptionRequest
) => {
  const response = await rewardsApi.post<Rewards.PromotionRedemption>(
    `/promotion-redemptions/${promotionUuid}/cancel`,
    promotionCancelBody
  );
  return response.data;
};

export const postPromotionRedemption = async (promotionRedemptionBody: Rewards.PromotionRedemptionRequest) => {
  const response = await rewardsApi.post<Rewards.PromotionRedemption>(
    `/promotion-redemptions`,
    promotionRedemptionBody
  );
  return response.data;
};

export const postPromotionRedemptionReapply = async (
  promotionUuid: string,
  promotionRedemptionApplyBody?: Rewards.PromotionReapplyRedemptionRequest
) => {
  const response = await rewardsApi.post<Rewards.PromotionRedemption>(
    `/promotion-redemptions/${promotionUuid}/reapply`,
    promotionRedemptionApplyBody
  );

  return response.data;
};

export const postPromotionRedemptionCancel = async (
  promotionUuid: string,
  promotionRedemptionCancelBody?: Rewards.PromotionCancelRedemptionRequest
) => {
  const response = await rewardsApi.post<Rewards.PromotionRedemption>(
    `/promotion-redemptions/${promotionUuid}/cancel`,
    promotionRedemptionCancelBody
  );

  return response.data;
};
